import React, { useState, useEffect } from 'react';
import Pagetitle from './PageTitle';
import useAsync from '../hooks/useAsync';
import AppServices from '../services/AppServices';

function AppSettings() {
  const { data, error, isLoading } = useAsync(AppServices.getApp);

  const [formValues, setFormValues] = useState({
    name: '',
    description: '',
    image: '',
    language: '',
    version: '',    
    status: '',
  });
  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png'); 
  useEffect(() => {
    // Check if data and data.data exist and have a length greater than 0
    if (data && data.data && data.data.length > 0) {
      const appData = data.data[0]; // Access the first element of the array
      setFormValues({
        name: appData.name || '',
        description: appData.description || '',
        language: appData.Language || '',
        version: appData.version || '',
        status: appData.status || '',
      });
      if (appData.image) {
        setPreviewImage(process.env.REACT_APP_URL + appData.image);
      }
      // Set the preview image
     
    }
  }, [data]);

  
  // Placeholder image path

  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      for (const key in formValues) {
    if (key !== 'image' || formValues[key] instanceof File) {
      formData.append(key, formValues[key]);
    } 
      }
      const response = await AppServices.updateApp(formData);
      console.log(response);
      alert('App Details Updated Successfully');
    } catch (error) {
      console.error('Failed to update app details', error);
      alert('Failed to update app details');
    }
  };
 

  return (
    <div className="right_col" role="main">
      <Pagetitle />
      <div className="container-box">
        <div className="container-box-inner px-4">
          <h5>General Settings</h5>
          <div className="page-details mt-3">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>App Name</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      value={formValues.name}
                      onChange={handleInputChange}
                      placeholder="Enter App Name"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>App Description</label>
                    <input
                      type="text"
                      name="description"
                      className="form-control"
                      value={formValues.description}
                      onChange={handleInputChange}
                      placeholder="Enter Description"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Language</label>
                    <select
                      className="form-control"
                      value={formValues.language}
                      onChange={handleInputChange}
                      name="language"
                    >
                      <option value="English">English</option>
                      <option value="Hindi">Hindi</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Upload Logo<span className="red">*</span></label>
                    <input type="file" name="image" className="form-control" onChange={handleFileChange} />
                    <div className="file-preview">
                      <img id="uploadFile" src={previewImage} alt="your image" />
                      
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="input-field">
                    <label>App Version</label>
                    <input
                      type="text"
                      name="version"
                      className="form-control"
                      value={formValues.version}
                      onChange={handleInputChange}
                      placeholder="App Version"
                    />
                  </div>
                </div>
              </div>
              <button className="site-btn-green" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppSettings;
